<template>
  <div>
    <slot></slot>
    <div v-if="loading" class="loading">Loading more…</div>
  </div>
</template>

<script>
import { listenerScrollToBottom } from '@/tools/tool.js'

export default {
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    listenerScrollToBottom(this.load)
  },
  methods: {
    load() {
      this.$emit('load')
    }
  }
}
</script>

<style lang="scss" scoped>
.loading {
  background-color: #ecedf3;
  text-align: center;
  line-height: 60px;
  font-size: 14px;
  color: #333333;
}
</style>
